export enum BookedOrderLinkEnum {
  SendEticket = 'SendEticket',
  SendInvoice = 'SendInvoice',
  TicketConditions = 'ticketConditions',
  HasMiniRules = 'hasMiniRules',
  MiniRules = 'miniRules',
  HasTicketConditions = 'ticketConditions'
}

export type BookedOrderLinkEnumType = keyof typeof BookedOrderLinkEnum;
